export default __webpack_public_path__ + "static/media/task-requests.bc6eb4a7.svg";